module.exports = __webpack_public_path__ + "media/images/s4p-logo-icon-861ce26a1339740870131747982cf0ca.svg";